import styled from "styled-components";
import { colors } from "../../common/ui/globalColors";

export const StyledInsuranceOfferPage = styled.div`
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    gap: 35px;
    width: 90%;
    align-items: center;
    color: ${colors.textColors.black};

    .img-wrapper {
        position: relative;
        display: flex;
        align-items: center;
      
        img{
          width: 500px;
        }
      
        .img-info {
            position: absolute;
            width: 345px;
            background: ${colors.semiTransparentColors.white07};
            box-shadow: 0px 8px 30px rgba(67, 57, 126, 0.1);
            border-radius: 20px;
            padding: 25px 15px;
            text-align: center;
            font-size: 20px;
            line-height: 26px;
        }
        .img-info.right {
            top: 0;
            right: -135px;
        }
        .img-info.left {
            left: -135px;
            bottom: 0;
        }
    }

    .insurance-actions {
      background: ${colors.semiTransparentColors.white07};
      box-shadow: 0px 8px 30px rgba(67,57,126,0.1);
      border-radius: 20px;
      padding: 20px;
      display: grid;
      grid-template-rows: 1fr 3fr;
      justify-items: center;
      gap: 25px;
      font-size: 25px;
      text-align: center;
      width: 50vw;
      min-width: 480px;

        .btns-wrapper {
            display: flex;
            flex-direction: column;
            gap: 20px;

            .app-btn {
                width: 450px;
                height: 70px;
                font-size: 20px;
                position: relative;

                .arrow {
                    transform: ${({ ltr }) => ltr ? 'rotate(180deg)' : 'rotate(0deg)'};
                    position: absolute;
                    right: ${({ ltr }) => ltr ? '10px' : ''};
                    left: ${({ ltr }) => ltr ? '' : '10px'};
                    height: 70%;
                }
            }
        }
    }

    @media screen and (max-width: 768px) {
        margin-top: 45px;
        gap: 34px;

        .img-wrapper {
            width: 90%;
            display: flex;
            flex-direction: column;
            gap: 8px;

            img {
                width: 100%;
            }
    
            .img-info {
                position: relative;
                width: 240px;
                padding: 10px 19px;
                font-size: 14px;
                line-height: 20px;
                top: unset !important;
                right: unset !important;
                left: unset !important;
            }
            .img-info.right {
                margin-top: -30px;
            }
        }

        .insurance-actions {
            padding: 47px 19px;
            gap: 17px;
            font-size: 20px;
            line-height: 26px;
            width: 100vw;
            min-width: 100px;
            .btns-wrapper {
                gap: 16px;
    
                .app-btn {
                    width: 100%;
                    height: 42px;
                    font-size: 14px;
                    margin-left: ${props => !props.ltr ? '56px': 0};
                }
            }
        }
    }
`
